import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const DropzoneContainer = styled(Box)<{ borderImage?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px;
  background-image: url(${(props) => props.borderImage});
  border-radius: 5px;
  overflow-wrap: anywhere;
`;
